import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { adminMe, adminLogout as apiAdminLogout } from "../lib/api";

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export default function AdminRoute({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    adminMe()
      .then((data) => { if (!cancelled) setAdmin(data); })
      .catch(() => { if (!cancelled) setAdmin(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tick]);

  const refresh = useCallback(() => setTick((t) => t + 1), []);

  const logout = useCallback(async () => {
    await apiAdminLogout();
    window.location.href = "/admin/login";
  }, []);

  const ctxValue = useMemo(() => ({ admin, refresh, logout }), [admin, refresh, logout]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA]">
        <Loader2 className="w-7 h-7 animate-spin text-[#2563EB]" />
      </div>
    );
  }

  if (!admin) return <Navigate to="/admin/login" replace />;

  return <AdminAuthContext.Provider value={ctxValue}>{children}</AdminAuthContext.Provider>;
}
